import BaseButton from "@/components_v2/Button/BaseButton";
import { BaseBannerProps } from "./types";

import "./styles.css";

const DEFAULT_BACKGROUND_COLOR = "#fff8f1";

const BaseBanner = ({
  title,
  description,
  icon,
  buttons,
  vertical = false,
  titleColor,
  descriptionColor,
  backgroundColor = DEFAULT_BACKGROUND_COLOR,
  className,
  style,
}: BaseBannerProps) => {
  const layoutClass = vertical
    ? "flex flex-col items-start gap-300"
    : "flex items-center gap-300";

  return (
    <div
      className={`base-banner ${layoutClass} ${className ?? ""}`.trim()}
      style={{ ...style, backgroundColor }}
      role="region"
      aria-label={title}
    >
      {icon && (
        <div className="flex items-center justify-center flex-shrink-0">
          {icon}
        </div>
      )}

      <div className={`base-banner-content ${vertical ? "" : "flex-1"}`.trim()}>
        <h2
          className="base-banner-title header-s-medium"
          style={titleColor ? { color: titleColor } : undefined}
        >
          {title}
        </h2>
        {description && (
          <p
            className="base-banner-description body-m-regular"
            style={descriptionColor ? { color: descriptionColor } : undefined}
          >
            {description}
          </p>
        )}
      </div>

      {buttons && buttons.length > 0 && (
        <div className="base-banner-action flex gap-200">
          {buttons.map((buttonProps, index) => (
            <BaseButton key={index} {...buttonProps} />
          ))}
        </div>
      )}
    </div>
  );
};

export default BaseBanner;
